import { render, staticRenderFns } from "./ConfigCtn.vue?vue&type=template&id=12b3172e&scoped=true"
import script from "./ConfigCtn.vue?vue&type=script&lang=js"
export * from "./ConfigCtn.vue?vue&type=script&lang=js"
import style0 from "./ConfigCtn.vue?vue&type=style&index=0&id=12b3172e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b3172e",
  null
  
)

export default component.exports